import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { collection, query, where, getDocs } from "firebase/firestore";
import { db} from '../LoginComp/firebase';
import './styles.css';


function AdvanceSearch() {


  const categories = [
    { name: "Researches", path: "/researchpaper" },
    { name: "E-Books", path: "/ebooks" },
    { name: "Articles", path: "/journalarticle" },
    { name: "Clinical Resources", path: "/clinicalresource" },
    { name: "Theses", path: "/thesis" },
  ];


  const [searchQuery, setSearchQuery] = useState("");
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(false);


    const [currentPage, setCurrentPage] = useState(1);


const searchBooks = async () => {
  if (!searchQuery.trim()) return;
  setLoading(true);

  try {
    const booksRef = collection(db, "mainresources");

    // Convert search query to lowercase for case-insensitive search
    const lowerCaseQuery = searchQuery.toLowerCase();

    // Search using 'array-contains-any' (for words matching searchKeywords array)
    const q = query(booksRef, where("searchKeywords", "array-contains-any", lowerCaseQuery.split(" ")));

    const snapshot = await getDocs(q);
    const results = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    setBooks(results);
  } catch (error) {
    console.error("Error fetching books:", error);
  }

  setLoading(false);
};



{/*advanced search*/}
// State to hold search input values
 // State to hold search input values
 const [searchParams, setSearchParams] = useState({
  title: "",
  author: "",
  publicationYear: "",
  description: "",
  isbn: "",
});

// State for search results & pagination
const [results, setResults] = useState([]);
const [currentShowPage, setCurrentShowPage] = useState(1);
const resultsPerPage = 2; // Max 2 resources per page

// Handle input changes
const handleInputChange = (e) => {
  setSearchParams({
    ...searchParams,
    [e.target.name]: e.target.value,
  });
};




// Function to fetch filtered articles
const fetchFilteredArticles = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const resourceRef = collection(db, "mainresources");
  let conditions = [];

  // Dynamically add filters if the user provided values
  if (searchParams.title) {
    conditions.push(where("title", ">=", searchParams.title), where("title", "<=", searchParams.title + "\uf8ff"));
  }
  if (searchParams.author) {
    conditions.push(where("author", "==", searchParams.author));
  }
  if (searchParams.publicationYearFrom) {
    conditions.push(where("publication_year", ">=", parseInt(searchParams.publicationYearFrom)));
  }
  if (searchParams.publicationYearTo) {
    conditions.push(where("publication_year", "<=", parseInt(searchParams.publicationYearTo)));
  }

  try {
    let q;

    if (conditions.length > 1) {
      // If multiple conditions exist, we must index them properly in Firestore
      q = query(resourceRef, ...conditions);
    } else if (conditions.length === 1) {
      // Single condition case
      q = query(resourceRef, conditions[0]);
    } else {
      // If no filters applied, fetch all resources
      q = query(resourceRef);
    }

    const querySnapshot = await getDocs(q);
    const articles = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setResults(articles);
    setCurrentShowPage(1); // Reset pagination when search updates
  } catch (error) {
    console.error("Error fetching filtered articles:", error);
  }
};




// Calculate total pages
const totalShowPages = Math.ceil(results.length / resultsPerPage);
const startIndex = (currentPage - 1) * resultsPerPage;
const paginatedResults = results.slice(startIndex, startIndex + resultsPerPage);

// Corrected Pagination Function
const Paginate = (pageNumber) => {
  if (pageNumber >= 1 && pageNumber <= totalShowPages) {
    setCurrentPage(pageNumber);
  }
};













  return (



 



   
    <div className="home-page">
    <div className="main-content">
      <section className="search-section">
        <h2>Search the Library</h2>
        <div className="search-bar-container">




        <div className="search-container">
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search by title, author, or specific area"
                className="search-input"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button className="search-button" onClick={searchBooks}>
                Search
              </button>
            </div>

            {loading && <p>Loading...</p>}

            <div className="results">
              {books.length > 0 ? (
                books.map((book) => (
                  <div key={book.id} className="book-item"> 
                    <h4>{book.title}</h4>
                    <p>
                      {book.author} | {book.publication_year} | {book.isbn} | {book.description}
                    </p>


                    {/* Download PDF link */}
                    {book.pdfFileURL && (
                      <a
                        href={book.pdfFileURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="resource-link"
                      >
                        Read More
                      </a>
                    )}
                  </div>
                ))
              ) : (
                !loading && <p>No results found</p>
              )}
            </div>
        </div>



        <section>
          <div className="advanced-options">
            <h3>Advanced Search</h3>
            <form className="advanced-search-form" onSubmit={fetchFilteredArticles}>
              <input type="text" name="title" placeholder="Title" className="search-input" value={searchParams.title} onChange={handleInputChange} />
              <input type="text" name="author" placeholder="Author" className="search-input" value={searchParams.author} onChange={handleInputChange} />
              <input type="number" name="publicationYearFrom" placeholder="Publication Year From" className="search-input" value={searchParams.publicationYearFrom} onChange={handleInputChange} />
              <input type="number" name="publicationYearTo" placeholder="Publication Year To" className="search-input" value={searchParams.publicationYearTo} onChange={handleInputChange} />

              <button type="submit" className="search-button">Search</button>
            </form>


            {/* Display Search Results */}
            <div className="search-results">
              {paginatedResults.length > 0 ? (
                paginatedResults.map((article) => (
                  <div key={article.id} className="article-item">
                    <h4>{article.title}</h4>
                    <p>{article.author} | {article.publication_year} | {article.isbn}</p>
                    <a href={article.pdfFileURL} target="_blank" rel="noopener noreferrer">Read More</a>
                  </div>
                ))
              ) : (
                <p>No results found.</p>
              )}
            </div>

            {/* Pagination */}
            {totalShowPages > 1 && (
              <div className="pagination-container">
                <button
                  className="pagination-button"
                  onClick={() => Paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                {Array.from({ length: totalShowPages }, (_, index) => (
                  <button
                    key={index + 1}
                    className={`pagination-button ${currentPage === index + 1 ? "active" : ""}`}
                    onClick={() => Paginate(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}
                <button
                  className="pagination-button"
                  onClick={() => Paginate(currentPage + 1)}
                  disabled={currentPage === totalShowPages}
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </section>

          
          {/* <div className="full-text-search">
            <h3>Full-Text Search</h3>
            <textarea placeholder="Enter text to search within documents" className="search-textarea"></textarea>
            <button className="search-button">Search</button>
          </div> */}

          
        </div>
      </section>                                                                                                                                                                                                                                                                                        
      </div>




      <section>
        <div className="category-container">
          {categories.map((category) => (
            <Link key={category.name} to={category.path} className="category-button">
              {category.name}
            </Link>
          ))}
        </div>
      </section>

      <section className="footer-cta">
        <h1 className="footer-cta-title">Join Us Today!</h1>
        <p className="footer-cta-text">
          Become a part of our community and begin your journey in the world of eye care and vision science.
        </p>
        <Link to="/signup">
          <button className="footer-cta-button">Explore Now</button>
        </Link>
      </section>


      </div>





  )
}

export default AdvanceSearch



